import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let tieMaRouter = new Router({
  routes: [{
      path: '/',
      name: 'mainPage',
      component: () => import('./views/mainPage.vue')
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('./views/Intro.vue')
    },
    {
      path: '/histories',
      name: 'histories',
      component: () => import('./views/Histories.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue')
    },
    {
      path: '/goin',
      name: 'goin',
      component: () => import('./views/GoIn.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/aboute.vue')
    }
  ]
})


export default tieMaRouter